module.exports = __webpack_public_path__ + "static/media/BETH.335efd22.png";